export const CORE_COLORS = {
  brandGreen: "#259c73",
  /**
   * The 立即訂閱 button green (`components/shared/nav/nav.tsx`). QA nominated
   * this exact colour as the hover state for article titles, categories and
   * excerpts across the main site, so it lives here rather than as a literal.
   */
  subscribeGreen: "#56917d",
  brandGreenDark: "#108a60",
  brandGreenDeep: "#003623",
  brandRed: "#d70d19",
  columnAccent: "#2a9da1",
  textPrimary: "#000000",
  textSecondary: "#6f6f6f",
  textTertiary: "#999999",
  surfaceMuted: "#f5f5f7",
  /**
   * Background for a disabled control that normally sits on a brand colour.
   * Use this INSTEAD of dimming the brand colour with `disabled:opacity-*`:
   * 40% of brandGreen still reads as green, and QA filed it as a bug —
   * "如果冇得滑動嘅話應該係要灰色 而唔係綠色".
   */
  disabledSurface: "#c4c4c4",
  dividerBold: "#111111",
  dividerSoft: "rgba(0,0,0,0.1)",
  dividerLight: "#eeeeee",
} as const;

export const CORE_FONT = {
  sans: "Roboto, 'Noto Sans TC', sans-serif",
  condensed: "'Roboto Condensed', Roboto, 'Noto Sans TC', sans-serif",
} as const;
